import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { FormGroup, Button, Col, Row, FormControl, Checkbox, ControlLabel} from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import debounce from "lodash/debounce";
import AdminService from "../../../services/AdminService";
import ProjectsService from "../../../services/ProjectsService";
import SearchService from "../../../services/SearchService";
import TasksService from "../../../services/TasksService";
import HandleError from "../../../services/HandleError";
import LoaderInline from "../../helpers/LoaderInline";
import InlineError from "../../messages/InlineError";

class TaskCreateForm extends Component {

    state = {
    	selectedEmployee: "",
    	selectedParentTask: "",
    	saveTaskLoading: false,
    	isLoadingProjects: true,
    	isLoadingAreas: false,
    	projects: [],
    	areas: [],
    	statuses: [],
    	formData:{ status_id: 2, forced_to_log: false },
    	errors: {},
    }

    componentDidMount = () => { 
    	this.getProjects(); 
    	const { state } = this.props.location;
    	if (state !== undefined) {
    		this.onProjectsSelectChange(state.project, "project_id");
    	}
    }

    onChange = (e) => {
    	this.setState({ formData: {...this.state.formData, [e.target.name]: e.target.value }});
    }

    onSelectChange = (option, name) => {
    	if (option !== null) {
    		this.setState({ formData: { ...this.state.formData, [name]: option.value || "" }});
    	}
    };
	
    onProjectsSelectChange = (option, name) => {
    	if(option !== null) {
    		this.setState({ formData: {...this.state.formData, [name]: option.value || "" }, isLoadingAreas: true });
    		new ProjectsService(this,`/${option.value}?user_task=true`).index().then((res) => {
    			this.setState({
    				isLoadingAreas: false,
    				areas: res.data.areas
    			});
    		}).catch((err) => {
    			this.setState({isLoadingAreas: false});
    			HandleError(err, this);
    		});
    	}
    }
	
	onEmployeeSelectChange = (employee) => {
		if(employee !== null) {
			this.setState({selectedEmployee: employee, formData:{...this.state.formData, assigned_to: employee.id }});
		} else {
			this.setState({selectedEmployee: null, formData:{...this.state.formData, assigned_to: null}});
		}
	}
	
	onParentSelectChange = (parentTask) => {
		if(parentTask !== null) {
			this.setState({selectedParentTask: parentTask, formData: {...this.state.formData, parent_id: parentTask.id} });
		} 
	}

	onCheckboxChange = (e) => {
    	this.setState({ formData: {...this.state.formData, [e.target.name]: e.target.checked }});
	}
	
	onSubmit = (e) => {
		e.preventDefault();
		this.setState({saveTaskLoading: true, errors: []});
		this.tasksService.store(this.state.formData).then((res) => {
			this.setState({ saveTaskLoading: false });	
			NotificationManager.success("Task created.","Success!");					
			this.props.history.push("/tasks/all-tasks");	 
		}).catch((err) => {
			this.setState({ saveTaskLoading: false });						
			HandleError(err, this);
		});
	}

    getProjects = () => {
    	this.projectsService.index().then((res) => {
    		this.setState({ isLoadingProjects: false, projects: res.data.projects, statuses: res.data.statuses });
    	}).catch((err) => {
    		this.setState({ isLoadingProjects: false });
    		HandleError(err, this);
    	});
    }
	
	handleAsyncSearch = (input = null, attribute, extra, callback) => {
		if (!input || !input.replace(/\s/g, "").length) {
		 callback(null, { complete: true });
		 return;
		}
		this.asyncCallback(input, attribute, extra, callback);
	}

	asyncCallback = debounce((input, attribute, extra, callback) => {
		this.searchService.searchByAttribute(attribute, input, extra).then((res) => {
			callback(null, {options: res.data , complete: true });
		}).catch((err) => {
			HandleError(err);
			callback(null, { complete: true });
		});
	}, 700);

	usersService = new AdminService(this,"users");   
    projectsService = new ProjectsService(this,"?task=true");
	searchService = new SearchService(this);
	tasksService = new TasksService(this)
	
	render() {
    	const { 
    		isLoadingProjects, isLoadingAreas, saveTaskLoading, 
    		formData, errors, projects, areas, statuses, selectedEmployee, selectedParentTask
		} = this.state;
		return (
    		<React.Fragment>
    			<Row>
    				<form onSubmit={this.onSubmit}>
    					<Col md={6} sm={12}>
    						<span className="column-title">Task details</span>
							<FormGroup validationState={errors.name && "error"}>
    							<ControlLabel>Name</ControlLabel>
    							<FormControl type="text" name="name" placeholder="Enter task name" value={formData.name || ""} onChange={this.onChange}/>
    							{errors.name && <InlineError text={errors.name} />}								                                
    						</FormGroup>							
							<Row>
								<Col md={6}>
									<FormGroup validationState={errors.project_id && "error"}>
										<ControlLabel>Project</ControlLabel>	
										<Select
											onChange={(option) => { this.onProjectsSelectChange(option, "project_id"); }}
											name="project_id"
											placeholder="Choose project "
											value={formData.project_id || ""}
											options={projects.map((project)=>({ value: project.id, label:project.name }))}
											isLoading={isLoadingProjects}
											clearable={false}
											multi={false}
										/>
										{errors.project_id && <InlineError text={errors.project_id} />}	
									</FormGroup>
								</Col>
								<Col md={6}>
									<FormGroup validationState={errors.area_id && "error"}>
										<ControlLabel>Area</ControlLabel>	
										<Select
											onChange={(option) => { this.onSelectChange(option, "area_id"); }}
											name="area_id"
											placeholder="Choose area "
											value={formData.area_id || ""}
											options={areas.map((area)=>({ value: area.id, label: area.name }))}
											isLoading={isLoadingAreas}
											clearable={false}
											multi={false}
										/>
										{errors.area_id && <InlineError text={errors.area_id} />}	
									</FormGroup>
								</Col>
							</Row>
							<Row>
								<Col md={6}>
									<FormGroup validationState={errors.status_id && "error"}>
										<ControlLabel>Status</ControlLabel>	
										<Select
											onChange={(option) => { this.onSelectChange(option, "status_id"); }}
											name="status_id"
											placeholder="Choose task status"
											value={formData.status_id || ""}
											options={statuses.map((status)=>({ value: status.id, label: status.name }))}
											isLoading={isLoadingProjects}
											clearable={false}
											multi={false}
										/>
										{errors.status_id && <InlineError text={errors.status_id} />}	
    								</FormGroup>
								</Col>
								<Col md={6}>
									<FormGroup validationState={errors.estimated && "error"}>
										<ControlLabel>Estimation (Hours)</ControlLabel>                                  
										<FormControl min="1" type="text" name="estimated" placeholder="Enter task estimation"  value={formData.estimated || ""} onChange={this.onChange}/>						
										{errors.estimated && <InlineError text={errors.estimated} />}								                                							
									</FormGroup>
								</Col>
							</Row>
							<FormGroup validationState={errors.assigned_to && "error"}>
								<ControlLabel>Assign to</ControlLabel>	
								<Select.Async
									onChange={(option) => { this.onEmployeeSelectChange(option, "assigned_to"); }}
									name="assigned_to"
									placeholder="Choose employee"
									value={selectedEmployee}
									labelKey="full_name"
									valueKey="id"
									loadOptions={(e,c) => this.handleAsyncSearch(e,"user","roles=2,4",c)}
									clearable={false}
									multi={false}
								/>
								{errors.assigned_to && <InlineError text={errors.assigned_to} />}
							</FormGroup>
							<FormGroup validationState={errors.description && "error"}>
    							<ControlLabel>Description</ControlLabel>                                  
    							<FormControl componentClass="textarea" name="description" placeholder="Enter task description"  value={formData.description || ""} onChange={this.onChange}/>						
    							{errors.description && <InlineError text={errors.description} />}								                                							
    						</FormGroup>
							<FormGroup validationState={errors.forced_to_log && "error"}>
    							<Checkbox name="forced_to_log" inline onChange={this.onCheckboxChange}>
                                    Force user to log at this task 
    							</Checkbox> 
								{errors.forced_to_log && <InlineError text={errors.forced_to_log} />}	
    						</FormGroup>
    						<FormGroup>
    							<Checkbox name="parent" inline onChange={this.onCheckboxChange}>
                                    Choose task parent
    							</Checkbox> 
    						</FormGroup>
    						{this.state.formData.parent && 
    							<FormGroup validationState={errors.parent_id && "error"}>
    								<ControlLabel>Parent Task</ControlLabel>	
    								<Select.Async
    									onChange={(option) => { this.onParentSelectChange(option, "parent_id"); }}
    									name="parent_id"
    									placeholder="Choose parent task"
    									value={selectedParentTask}
    									labelKey="name"
    									valueKey="id"
    									loadOptions={(e,c) => this.handleAsyncSearch(e,"task",null,c)}
    									clearable={false}
    									multi={false}
    								/>
    								{errors.parent_id && <InlineError text={errors.parent_id} />}	
    							</FormGroup>
    						}

    						<Button className="btn-crud" bsStyle="primary" disabled={saveTaskLoading} type="submit">{saveTaskLoading?"Saving...":"Save"}</Button> 
    						{ saveTaskLoading ? <LoaderInline width="30" height="30" color="#2196f3"/> :  null }																												
    					</Col>	
    				</form>						
    			</Row>
    		</React.Fragment>
    	);
	}
}

TaskCreateForm.defaultProps = {
	location: PropTypes.shape({
		state: null,
	}),
};

TaskCreateForm.propTypes = {
	history: PropTypes.shape({
		push: PropTypes.func.isRequired
	}).isRequired,
	location: PropTypes.shape({
		state: PropTypes.shape({
			project: PropTypes.shape({
				value: PropTypes.number,
				label: PropTypes.string,
			}),
		}),
	})
};
export default TaskCreateForm;


// WEBPACK FOOTER //
// ./src/components/forms/tasks/TaskCreateForm.js